const languageObj = {
  "Cut Audio": "قطع الصوت",
  "HitPaw Online Audio Cutter": "قاطع الصوت عبر الإنترنتHitPaw",
  "Trim or cut any audio files online.": "تقليم أو قص أي ملفات صوتية عبر الإنترنت.",
  "Cut": "يقطع",
  "Fade in": "اختفي",
  "Fade out": "تتآكل",
  "Cut from": "قطع من",
  "to": "إلى",
  "Extract selection": "استخراج التحديد",
  "Delete selection": "حذف التحديد",
  "Adjust New": "ضبط جديد",
  "Cut New": "قص جديد",
  "Adjust Volume": "ضبط مستوى الصوت",
  "HitPaw Online Volume Changer": "مغير حجم عبر الإنترنت HitPaw",
  "Turn up or Turn down the volume of audio.": "ارفع أو اخفض مستوى الصوت.",
  "Volume": "مقدار",
  "Change Speed": "تغيير السرعة",
  "HitPaw Online Audio Speed Changer": "مغير سرعة الصوت عبر الإنترنت HitPaw",
  "Speed up or slow down audios online easily.": "تسريع أو إبطاء الصوتيات عبر الإنترنت بسهولة.",
  "Speed": "سرعة",
  "Format": "صيغة",
  "Size": "بحجم",
  "Duration": "مدة",
};

export default languageObj